import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__user_credentials extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.USER_CREDENTIALS;

  /*
   * DB FIELDS
   */
  email!: string;
  password!: string;

  /*
   * METHODS
   */

  constructor(email: string = '', password: string = '') {
    super();

    this.email = email;
    this.password = password;
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.email);
    assert_string_not_empty(this.password);
  }
}
